module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10244.9ebef664.jpg";